import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useProfileData } from '../../hooks/useProfileData';
import { useAuth } from '../../hooks/useAuth';
import UserProfilePage from './userProfileData';
import { usePreloadedIndex } from '../../hooks/usePreloadedIndex';
import LoadingPage from '../LoadingPage';
import { useProductData } from '../../hooks/useProductData';
import { toast } from 'react-toastify';

export default function CreatorProfile({ passedProduct }) {
  const { userName: userNameParam } = useParams();
  const userName = userNameParam?.toLowerCase();
  const {loadProductByShortCode} = useProductData();
  const [,] = usePreloadedIndex();
  const navigate = useNavigate();
  const { authUser } = useAuth();
  const { fetchProfileDataFromUserName, creatorProfileData, isLoadingProfile } =
    useProfileData();

    
  const [searchParams] = useSearchParams();
  const shortCode = searchParams.get('s_id')

  useEffect(() => {
    if (userName && creatorProfileData?.userName.toLowerCase() !== userName) {
      checkValidUserAndFetchProfileData();
    }
  }, [userName, creatorProfileData, shortCode, searchParams]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if authUser is updated, also update creatorProfileData
    if (authUser?.userName === creatorProfileData?.userName.toLowerCase()) {
      checkValidUserAndFetchProfileData();
    }
  }, [authUser, shortCode, searchParams]);

  const checkValidUserAndFetchProfileData = async () => {
    fetchProfileDataFromUserName(userName, authUser?.uid, true, () => {
      navigate('/creators');
    });
  };

  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  useEffect(() => {
    if (!creatorProfileData) return;

    if (shortCode) {
      (async () => {
        try {
          const data = await loadProductByShortCode(creatorProfileData.userId, shortCode);
          setRedirectTo(
            data?.id
              ? `/${userName}/product/chat?p_id=${data.id}`
              : `/${userName}`
          );
          if (!data || !data.id) {
            toast.error('Product not available')
          }
        } catch {
          toast.error('Product not available')
          setRedirectTo(`/${userName}`);
        }
      })();
    } else {
      const productId = searchParams.get('p_id');
      if (productId) {
        setRedirectTo(`/${userName}/product/chat?p_id=${productId}`);
      }
    }
  }, [shortCode, creatorProfileData?.userId, userName, searchParams, loadProductByShortCode]);

  useEffect(() => {
    if (!redirectTo) return;
    navigate(redirectTo, { replace: true });
    setRedirectTo(null);
  }, [redirectTo, navigate]);

  return shortCode ?
    (<LoadingPage />
    ):
    (<Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {(userName &&
        creatorProfileData?.userName.toLowerCase() !==
          userName.toLowerCase()) ||
      (!creatorProfileData?.index && isLoadingProfile) ? (
        <LoadingPage />
      ) : (
        <UserProfilePage passedProduct={passedProduct} />
      )}
    </Box>
  );
}
